import { RootState, useSelector } from '../redux/store';
import { ROLE } from '../constants';
import type { Role } from '../types/common';

const useUserRoles = () => {
  const { roles } = useSelector((state: RootState) => state.session);
  const isUser: boolean = roles && roles.includes(ROLE.USER);
  const isPoweruser: boolean = roles && roles.includes(ROLE.POWERUSER);
  const isAdmin: boolean = roles && roles.includes(ROLE.ADMIN);
  const isMaintenanceadmin: boolean = roles && roles.includes(ROLE.MAINTENANCE_ADMIN);
  const adminAndPoweruser: Role[] = [ROLE.POWERUSER, ROLE.ADMIN];
  const isAdminOrPoweruser: boolean = roles && adminAndPoweruser.some((role) => roles.includes(role));
  const hasNoRole: boolean = roles && roles.length === 0;

  return {
    isUser,
    isAdmin,
    isPoweruser,
    isMaintenanceadmin,
    isAdminOrPoweruser,
    hasNoRole,
  };
};

export default useUserRoles;
